import classNames from "classnames";
import { Button } from "@netapp/bxp-design-system-react";
import { useTranslation } from 'react-i18next';
import MenuLinkItem from "./MenuLinkItem";
import { leftNav as i18nNamespace } from "../../../../i18n/namespace";
import styles from "../MainHeader.module.scss";

function PermissionMenuLink({hasPermission, title, disabled, to}) {
    const { t } = useTranslation(i18nNamespace);

    if(!hasPermission) {
        return (
            <Button variant="text"
                tooltip={t('user_do_not_have_access')}
                disabled={true}
                className={classNames(styles['menu-content-link-button'], styles['font-inherit'])}

              >
                    {title}
            </Button>
        )
    }

    return (
        <MenuLinkItem disabled={disabled} to={to}>
            {title}
        </MenuLinkItem>
    )
}

export default PermissionMenuLink